/** @deprecated use 'redux/types/state.interface/status' */
export enum Vendor {
  DOOR_DASH = 0,
  UBER_EATS = 1,
}
